import React, { SVGProps } from "react";

export default function SupPinRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.7 9.59993V9.89993V10.0999V10.3999V13.1999C12.7 13.8074 12.2075 14.2999 11.6 14.2999H10.8944C10.5356 14.2999 10.2077 14.0972 10.0472 13.7763C9.71737 13.1166 9.04312 12.6999 8.30557 12.6999H4.96569C4.47088 12.6999 3.99633 12.8965 3.64645 13.2464L3.57782 13.315L3.93137 13.6686L3.57782 13.315C3.45941 13.4334 3.29882 13.4999 3.13137 13.4999C2.78267 13.4999 2.5 13.2173 2.5 12.8686L2.5 7.1313C2.5 6.7826 2.78267 6.49993 3.13137 6.49993C3.29882 6.49993 3.45941 6.56645 3.57782 6.68485L3.64645 6.75348C3.99633 7.10336 4.47087 7.29993 4.96569 7.29993H8.30557C9.04312 7.29993 9.71737 6.88322 10.0472 6.22353C10.2077 5.90263 10.5356 5.69993 10.8944 5.69993H11.6C12.2075 5.69993 12.7 6.19241 12.7 6.79993V9.59993Z"
        stroke="currentColor"
      />
    </svg>
  );
}
